"use strict";

var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NegativeSpaceLens = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var LensTop_1 = require("./LensTop");
var LensLeft_1 = require("./LensLeft");
var LensRight_1 = require("./LensRight");
var LensBottom_1 = require("./LensBottom");
exports.NegativeSpaceLens = (0, react_1.forwardRef)(function (props, ref) {
  var cursorOffset = props.cursorOffset,
    fadeDurationInMs = props.fadeDurationInMs,
    isActive = props.isActive,
    isPositionOutside = props.isPositionOutside,
    position = props.position,
    userSpecifiedStyle = props.style,
    rest = __rest(props, ["cursorOffset", "fadeDurationInMs", "isActive", "isPositionOutside", "position", "style"]);
  var compositLensStyle = Object.assign({
    backgroundColor: 'rgba(0,0,0,.4)'
  }, userSpecifiedStyle);
  return (0, jsx_runtime_1.jsxs)("div", Object.assign({}, rest, {
    children: [(0, jsx_runtime_1.jsx)(LensTop_1.LensTop, Object.assign({}, props, {
      ref: ref,
      style: compositLensStyle
    }), void 0), (0, jsx_runtime_1.jsx)(LensLeft_1.LensLeft, Object.assign({}, props, {
      ref: ref,
      style: compositLensStyle
    }), void 0), (0, jsx_runtime_1.jsx)(LensRight_1.LensRight, Object.assign({}, props, {
      ref: ref,
      style: compositLensStyle
    }), void 0), (0, jsx_runtime_1.jsx)(LensBottom_1.LensBottom, Object.assign({}, props, {
      ref: ref,
      style: compositLensStyle
    }), void 0)]
  }), void 0);
});
exports.NegativeSpaceLens.displayName = 'NegativeSpaceLens';